import axios from "axios";
import isUndefined from "lodash/isUndefined";

const __cache = {};
const isProductionEnv = process.env.BUILD_ENV === "prod";

export default async function __get__short__link(longLink) {
  const cache = __cache[longLink];

  if (!isUndefined(cache)) {
    return cache;
  }

  let shortLink = "";
  try {
    const {
      data: { data, success },
    } = await axios.get(
      // 直接使用线上的，因为 https://test-mall.akulaku.com/url/encode 已经被回收了
      "https://al.plus/url/encode",
      { params: { url: longLink } },
      { timeout: 1000 * 8 } //8秒超时
    );
    if (success) {
      shortLink = data;
    } else {
      shortLink = longLink;
    }
  } catch (err) {
    shortLink = longLink;
  }

  __cache[longLink] = shortLink;

  return shortLink;
}
